import { makeAutoObservable } from "mobx";
import TimeZoneService from "../services/TimeZoneService";
import { TimeZoneModel } from "../models/TimeZoneModel";

class TimeZoneStore {
  timeZones: TimeZoneModel[] = [];
  error: string | null = null;
  loading: boolean = true;

  constructor() {
      makeAutoObservable(this);
      this.loadTimeZones();
  }

  loadTimeZones() {
      this.loading = true;
      if (this.timeZones.length > 0) {
          this.loading = false;
          return;
      }
      TimeZoneService.getTimeZones().subscribe({
          next: (response) => {
              this.timeZones = response.result.map((c) => TimeZoneModel.deserialize(c));
              this.loading = false;
          },
          error: (err) => {
              this.error = 'Failed to load time zones';
              this.loading = false;
              console.error(err);
          },
      });
  }
}

export default new TimeZoneStore();
